var exports = {
  "D": "xfd349460--b33dc9--click-area",
};

module.exports = exports;
